<template>
      <card>
        <list
              :columns="columns"
              :modalCreate="modalCreate"
              :removeLink="removeLink"
              :cardLink="cardLink"
              :isUpdate="true"
              :isAdd="true"
              :itemLink="itemLink"
              :setLink="setLink"
              :openItem="true"
              :fields="fields"
              :searchDisable="true"
              @change="change"
              @changeFunction="changeFunction"
              v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "season",
        fields: [
    {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          col:'col-12 col-md-6',
          key: "from_at",
          label: "Начало учебного сезона",
          type: "date",
          textType: "text",
          readonly: false,
           dateFormat: true,
      },
      {
                col:'col-12 col-md-6',
        key: "till_at",
        label: "Окончание учебного сезона",
        type: "date",
        textType: "text",
        readonly: false,
           dateFormat: true,
      },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_season",
      itemLink: "business/seasons",
      setLink: "business/seasons",
      columns: [
     {
          key: "title",
          title: "Учебный сезон",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
            dateFormat:true,
            key: "from_at",
            title: "С",
          // disableLink: true,
        },
        {
            dateFormat:true,
            key: "till_at",
            title: "По",
            // disableLink: true,
        },
 
        {
          
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
